import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "./useWeb3";
import environment from "../utils/Environment";
import { insuranceContract } from "../utils/contractHelpers";

export const IsClaimAvailable = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = environment.insurance;
  const contract = insuranceContract(tokenAddress, web3);
  const isClaimAvailable = useCallback(async () => {
    try {
      console.log("indexes calling: ");

      var approved;
      approved = await contract.methods.indexes(account).call();
      console.log("indexes: ", approved);

      return approved;
    } catch (err) {
      console.log("aganssaf", err);
    }
  }, [account, contract]);

  return { isClaimAvailable: isClaimAvailable };
};

export default IsClaimAvailable;
